import { useReducer, createContext } from 'react'

import { activeUser } from 'src/types/user'

const theme: 'dark' | 'light' = localStorage.getItem('theme') === 'dark' ? 'dark' : 'light'

export const initialState = {
  user: null as activeUser | null,
  theme,
}

type tInitialState = typeof initialState

export type actionTypes =
  | { type: 'LOGIN'; payload: activeUser }
  | { type: 'LOGOUT'; payload?: undefined }
  | { type: 'RIGHTS'; payload: string[] }
  | { type: 'THEME'; payload: 'light' | 'dark' }

/* istanbul ignore next */
const defaultDispatch: React.Dispatch<actionTypes> = () => {
  throw new Error("app-dispatch without provider")
}

const defaultHaveRight = (_right: string) => false

export const AppContext = createContext({
  appState: initialState,
  appDispatch: defaultDispatch,
  haveRight: defaultHaveRight,
})

const reducer = (
  state: tInitialState, 
  action: actionTypes,
) => {
  switch (action.type) {

    case 'LOGIN':
      return {
        ...state,
        user: action.payload,
      }
    case 'LOGOUT':
      return {
        ...state,
        user: null
      }
      
    case 'RIGHTS':
      /* istanbul ignore next */
      if (!state.user) return state
      return {
        ...state,
        user: {
          ...state.user,
          rights: action.payload,
        }
      }

    case 'THEME':
      return {
        ...state,
        theme: action.payload,
      }
    
    /* istanbul ignore next */
    default: throw new Error("unknown 'app' action")
  }
}

interface Props {
  children: React.ReactNode
  startState?: tInitialState
  mockDispatch?: React.Dispatch<actionTypes>
}

export const AppContextProvider = ({ children, startState, mockDispatch }: Props) => {
  const [state, dispatch] = useReducer(reducer, startState || initialState)

  const haveRight = (right: string) => {
    /* istanbul ignore next */
    if (!state.user) return false
    return state.user.rights.includes(right)
  }

  return <AppContext.Provider value={{
    appState: state,
    appDispatch: mockDispatch || dispatch,
    haveRight,
  }}>
    {children}
  </AppContext.Provider>
}